import { useContext as n } from "react";
import { useTranslation as s } from "react-i18next";
import { getUseLocoTranslation as r, defaultNS as i } from "@systemeio/util";
import { LocaleContext as m } from "./context.mjs";
const o = [i], p = () => o, T = r({
  useTranslation: (t, a) => {
    const { i18n: e } = n(m) ?? {};
    return s(t, {
      i18n: e,
      ...a
    });
  },
  defaultNamespaces: o,
  namespaceMapper: p
});
export {
  T as useTranslation
};
